import type { FaireProductEntity } from "../../entity_types/product";

export const p_rffayupe4t: FaireProductEntity = {
  token: "p_rffayupe4t",
  type: "product",
  name: "The Lemonade Gang",
  brandToken: "b_2zlerrpi5b",
  brandName: "Subtle Tea",
  imageUrl:
    "https://cdn.faire.com/fastly/e1bbca54ca61cc2f1c3e91d6ce7aca0b13e47e936229178e59ac5277f6ee18cc.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/117ba164934686c8d85627c35a264f892daded83cdd2809c4a254c6d5f391b3d.jpeg",
    "https://cdn.faire.com/fastly/989bda69f03a9686d6e29d63651d2fa998438cb440d0738540f3f787b7e55e80.jpeg",
    "https://cdn.faire.com/fastly/9383dd20eeac6478c1f807604ef691494e5f4499f0558e21dec4b39f42eab388.jpeg",
    "https://cdn.faire.com/fastly/8aec21c6391abfa2d7734d3895c28b4329fb59b12e7513e55d15913077dc74be.jpeg",
    "https://cdn.faire.com/fastly/8e28f14e484a0e9d50e9f6fe576f16945f47b0f1ad866bdb38342111ab635cc3.jpeg",
    "https://cdn.faire.com/fastly/b1712cd9c454efc6ca55e4b47e660a7d8dec6788caae7de9d50781434c93f65b.jpeg",
  ],
  priceDollars: 44.33,
  description:
    "The Lemonade Gang is a mixed case with 4 of each of our lemonades.\n4 - Tea-Monade\n4 - Peach Brewed Lemonade\n4 - Real Lemonade",
  tags: [],
  msrpDollars: 88.66,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:50:19.053Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
